import React from "react";


// Dialog để thêm mới subject/topic/curiosity type
type AddItemDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onAddSubject: () => void;
  onAddTopic: () => void;
  onAddCuriosityType: () => void;
  mode: 'subject' | 'topic' | 'curiosityType';
  setMode: (mode: 'subject' | 'topic' | 'curiosityType') => void;
  newSubject: string;
  setNewSubject: (val: string) => void;
  newSubjectEn: string;
  setNewSubjectEn: (val: string) => void;
  newTopic: string;
  setNewTopic: (val: string) => void;
  newTopicEn: string;
  setNewTopicEn: (val: string) => void;
  newCuriosityType: string;
  setNewCuriosityType: (val: string) => void;
  newCuriosityTypeEn: string;
  setNewCuriosityTypeEn: (val: string) => void;
  t: (vi: string, en: string) => string;
};

const AddItemDialog = ({
  isOpen,
  onClose,
  onAddSubject,
  onAddTopic,
  onAddCuriosityType,
  mode,
  setMode,
  newSubject, setNewSubject, newSubjectEn, setNewSubjectEn,
  newTopic, setNewTopic, newTopicEn, setNewTopicEn,
  newCuriosityType, setNewCuriosityType, newCuriosityTypeEn, setNewCuriosityTypeEn,
  t
}: AddItemDialogProps) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 min-w-[340px] max-w-[90vw]">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-bold text-lg">
            {t('Thêm mới', 'Add new')} {mode === 'subject' ? t('môn học', 'subject') : mode === 'topic' ? t('chủ đề', 'topic') : t('tò mò', 'curiosity')}
          </h3>
          <button onClick={onClose} className="text-gray-500 hover:text-black text-xl">&times;</button>
        </div>
        <div className="flex space-x-2 mb-4">
          <button
            className={`px-2 py-1 rounded ${mode === 'subject' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            onClick={() => setMode('subject')}
          >{t('Môn học', 'Subject')}</button>
          <button
            className={`px-2 py-1 rounded ${mode === 'topic' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            onClick={() => setMode('topic')}
          >{t('Chủ đề', 'Topic')}</button>
          <button
            className={`px-2 py-1 rounded ${mode === 'curiosityType' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            onClick={() => setMode('curiosityType')}
          >{t('Tò mò', 'Curiosity')}</button>
        </div>
        {mode === 'subject' && (
          <div>
            <input
              type="text"
              value={newSubject}
              onChange={e => setNewSubject(e.target.value)}
              placeholder={t('Tên môn học (Việt)', 'Subject name (Vietnamese)')}
              className="border p-1 rounded w-full mb-2"
            />
            <input
              type="text"
              value={newSubjectEn}
              onChange={e => setNewSubjectEn(e.target.value)}
              placeholder={t('Tên môn học (Anh)', 'Subject name (English)')}
              className="border p-1 rounded w-full mb-2"
            />
            <button
              onClick={() => { onAddSubject(); onClose(); }}
              className="bg-green-600 text-white px-4 py-1 rounded w-full"
            >{t('Thêm môn học', 'Add subject')}</button>
          </div>
        )}
        {mode === 'topic' && (
          <div>
            <input
              type="text"
              value={newTopic}
              onChange={e => setNewTopic(e.target.value)}
              placeholder={t('Tên chủ đề (Việt)', 'Topic name (Vietnamese)')}
              className="border p-1 rounded w-full mb-2"
            />
            <input
              type="text"
              value={newTopicEn}
              onChange={e => setNewTopicEn(e.target.value)}
              placeholder={t('Tên chủ đề (Anh)', 'Topic name (English)')}
              className="border p-1 rounded w-full mb-2"
            />
            <button
              onClick={() => { onAddTopic(); onClose(); }}
              className="bg-green-600 text-white px-4 py-1 rounded w-full"
            >{t('Thêm chủ đề', 'Add topic')}</button>
          </div>
        )}
        {mode === 'curiosityType' && (
          <div>
            <input
              type="text"
              value={newCuriosityType}
              onChange={e => setNewCuriosityType(e.target.value)}
              placeholder={t('Tên tò mò (Việt)', 'Curiosity intention (Vietnamese)')}
              className="border p-1 rounded w-full mb-2"
            />
            <input
              type="text"
              value={newCuriosityTypeEn}
              onChange={e => setNewCuriosityTypeEn(e.target.value)}
              placeholder={t('Tên tò mò (Anh)', 'Curiosity intention (English)')}
              className="border p-1 rounded w-full mb-2"
            />
            <button
              onClick={() => { onAddCuriosityType(); onClose(); }}
              className="bg-green-600 text-white px-4 py-1 rounded w-full"
            >{t('Thêm tò mò', 'Add curiosity')}</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddItemDialog;
